import { TProps } from './types/TProps';

export const EndpointCard = ({ method, path, summary, children }: TProps) => (
  <section className="mb-6 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface)]">
    <div className="flex flex-wrap items-center gap-3 border-b border-[var(--color-border)] px-4 py-3">
      {method}
      <code className="font-mono text-sm font-semibold text-[var(--color-text)]">{path}</code>
      <span className="text-sm text-[var(--color-text-subtle)]">{summary}</span>
    </div>
    <div className="flex flex-col gap-4 px-4 py-4 text-sm text-[var(--color-text)]">{children}</div>
  </section>
);
